import React from "react";
import { Link as RouterLink } from "react-router-dom";

import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import Link from "@material-ui/core/Link";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

import KeyValue from "../display/KeyValue";
import StatusChip from "../chips/StatusChip";

import {
  MEDIA_THUMBNAIL_URL,
  PLACEHOLDER_IMG_360x360_URL,
  PLACEHOLDER_IMG_360x360_ERROR_URL,
} from "../../config";

const useStyles = makeStyles((theme) => ({
  card: {
    width: 250,
    margin: "20px",
    backgroundColor: "#212121",
  },
  img: {
    width: 250,
    height: 135,
    margin: "auto",
    objectFit: "cover",
  },
}));

export default function AdmCard({
  name,
  admId,
  status,
  mediaId,
  locationCount,
}) {
  const classes = useStyles();

  return (
    <Card className={classes.card}>
      <CardHeader
        title={
          <Link
            color="inherit"
            component={RouterLink}
            to={`/adm-areas/${admId}`}
            underline="none"
          >
            <Typography variant="body2">{name}</Typography>
          </Link>
        }
        subheader={
          <Typography variant="overline" color="textSecondary">
            {admId}
          </Typography>
        }
      />
      <CardMedia className={classes.media}>
        <img
          className={classes.img}
          alt=""
          src={
            !!mediaId
              ? `${MEDIA_THUMBNAIL_URL}/${mediaId}?width=240`
              : PLACEHOLDER_IMG_360x360_URL
          }
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = PLACEHOLDER_IMG_360x360_ERROR_URL;
          }}
        />
      </CardMedia>
      <CardContent>
        <StatusChip status={status} />
        <KeyValue
          keyName="Location Count"
          value={`${locationCount}`}
          link={`/adm-areas/${admId}/locations`}
        />
      </CardContent>
    </Card>
  );
}
